import styled from "styled-components";

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing * 2}px;
`;

export const Chip = styled.div`
  padding: ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 1}px ${({ theme }) => theme.spacing * 2}px ${({ theme }) => theme.spacing * 3}px;
  border-radius: ${({ theme }) => theme.radius}px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  color: ${({ theme }) => theme.colors.gray[900]};
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing}px;
  .label {
    font-weight: bold;
  }
  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background-color: unset;
    border: none;
    border-radius: 50%;
    > svg {
      width: 18px;
      height: 18px;
      > g, path {
        fill: ${({ theme }) => theme.colors.gray[900]};
      }
    }
    &:hover {
      background-color: ${({ theme }) => theme.colors.gray[200]};
    }
  }
`;
